import React from "react";
import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import { Container, Heading, Image,TEXT ,ImageContainer} from "./styled.components";
import subsidiary from "../../assets/images/subsidiary.jpg";
const Subsidiary = () => {

  return (
    <>
      <Layout>
        <Hero
          title="Subsidiary"
          SubTitle="HHH and Sons Presents a Proud Past And Will  Keep The Promise For Days To Come"
        />
        <Container>
          <Heading>
            <span>HHH</span>
            <br />
            Imports <span>& </span>Exports
          </Heading>
          <ImageContainer>
          <Image src={subsidiary}></Image></ImageContainer>
          <TEXT>
            The CEO Haji Hamid Hussain took a visionary step and launched a key
            subsidiary that is the import/export department in the HHH. The
            vision was to cater the project demand for equipments
            /plants/electrical panels to benefit the company as well as our
            country. Over the years HHH has established contacts and relation
            with respective companies in China and Korea. HHH imports of various
            equipments in the field of hydel projects implementation. We not
            only provide solutions, but also import HYDRO TURBINES (Pelton
            wheel, Cross Flow, Cross flow t-15, Kaplan, Tp100-dM.S pipes with
            different diameters Bends Reducers Expansion Joints Hydraulic Gates
            for channels Trash RacksBell Mouths) Motors, Electrical Panels,
            Wires etc. The company has the experience and is importing various
            different items of highway machinery from Korea. Our major imports
            from Korea are construction machineries/excavators / mixture
            machines/ vibrators (different types and different categories)
            compactors (different types and different categories) etc.
          </TEXT>
        </Container>
      </Layout>
    </>
  );
};

export default Subsidiary;
